export const ItemTypes = {
     PHOTO: 'photo',
  }
  